import { CryptoNews } from "../../components";

function NewsPage() {
   return <CryptoNews />;
}

export default NewsPage;
